import { render, staticRenderFns } from "./BaseStepper1.vue?vue&type=template&id=4a5c3e32&scoped=true"
import script from "./BaseStepper1.vue?vue&type=script&lang=js"
export * from "./BaseStepper1.vue?vue&type=script&lang=js"
import style0 from "./BaseStepper1.vue?vue&type=style&index=0&id=4a5c3e32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5c3e32",
  null
  
)

export default component.exports